export default __webpack_public_path__ + "static/media/screenBlock17.acba3c42.jpg";